const handleVibration = (repeatCount) => {
    if (window.Telegram && window.Telegram.WebApp.HapticFeedback) {
        for (let i = 0; i < repeatCount; i++) {
            window.Telegram.WebApp.HapticFeedback.impactOccurred('heavy');
        }
    } else {
        console.log('텔레그램 환경에서 햅틱 효과를 사용할 수 없습니다.');
    }
};

const changeNum = (n) => {
    let num = String(n)
    let arr = num.split('.')
    let result;

    if (arr[1]) {
        result = Number(arr[0]).toLocaleString() + "." + arr[1]
    }
    else {
        result = Number(arr[0]).toLocaleString()
    }

    return result;
}

const Decimalization = (n) => {
    let str = String(n).toUpperCase()
    let arr = str.split('E-')
    let result;
    if (arr[1]) {
        result = (Number(arr[0]) / Math.pow(10, Number(arr[1]))).toFixed(Number(arr[1]) + arr[0].length - 2)
    }
    else {
        result = arr[0]
    }

    return result
}

const RoundDown = (n, p) => {
    let num = Decimalization(n)
    let arr = num.split('.')
    let result;

    if (arr[1] && arr[1].length > p && p != 0) {
        let point = arr[1].slice(0, Number(p))
        result = arr[0] + "." + point
    }
    else if (arr[1] && arr[1].length <= p && p != 0) {
        let zero = ''
        let len = p - arr[1].length
        for (let i = 0; i < len; i++) {
            zero += '0'
        }
        result = arr[0] + "." + arr[1] + zero
    }
    else {
        result = Number(arr[0]).toFixed(p)
    }

    return changeNum(result);
}

const changeUnits = (n) => {
    let num = Number(n)
    let result;

    if (num >= 10000000000000) result = RoundDown(String(n / 1000000000000), 0) + 'T'
    else if (num >= 10000000000) result = RoundDown(String(n / 1000000000), 0) + 'B'
    else if (num >= 10000000) result = RoundDown(String(n / 1000000), 0) + 'M'
    else if (num >= 10000) result = RoundDown(String(n / 1000), 0) + 'K'
    else result = changeNum(n)

    return result;
}

const changeUnitsOrigial = (n) => {
    let num = Number(n)
    let result;

    if (num >= 1000000000000) result = RoundDown(String(n / 1000000000000), 2) + 'T'
    else if (num >= 1000000000) result = RoundDown(String(n / 1000000000), 2) + 'B'
    else if (num >= 1000000) result = RoundDown(String(n / 1000000), 2) + 'M'
    else if (num >= 1000) result = RoundDown(String(n / 1000), 2) + 'K'
    else result = changeNum(n)

    return result;
};

export { handleVibration, changeNum, changeUnitsOrigial, changeUnits }